<div fxLayout="column" fxLayoutGap="20px">

  <!-- Shipping modes -->
  <div fxLayout="column" fxLayoutGap="10px" *ngIf="type === 'delivry'">

    <!-- Shipping modes title-->

    <div fxLayout="row" fxLayoutAlign="space-between center"
      *ngIf="shippingModes && currSM.enable_shipping_cost > 0 && type === 'delivry' && shippingModes.length >0 && displaytitle">
      <span class="title-endorder-card boldest">{{
        "endorder.delivery-modes-title" | translate | capitalize
        }}</span>

    </div>

    <!-- Shipping modes -->
    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5px"
      *ngIf="shippingModes && currSM.enable_shipping_cost > 0 && type === 'delivry' && shippingModes.length >0">

      <div *ngFor="let shippingMode of shippingModes" fxLayout="row" fxLayoutGap="20px">
        <div  *ngIf="isInCountry(shippingMode)"  (click)="selectShippingMode(shippingMode);"
        [class.cost-selected]="(currAddress$ && currAddress$.shipping_mode) && shippingMode.id === currAddress$.shipping_mode.id"
         fxLayout="row" fxLayoutGap="20px" class=" clicked"
              [ngClass]="cssService.sectionCardClass"
         style="position: relative;">

        <div fxLayoutAlign="center center" class="primary cost-selected-ico"
          *ngIf="(currAddress$ && currAddress$.shipping_mode) && shippingMode.id === currAddress$.shipping_mode.id">
          <i class="fas fa-check whited-ico"></i>
        </div>

        <img src="assets/img/refonte-logo/logo-mondialrelay.png"  class="h-10"*ngIf="shippingMode.is_relay >0">
        <img src="assets/img/refonte-logo/logo-chronopost.png"  class="h-10"
          *ngIf="stringContain(shippingMode.name, 'chronopo')">
        <img src="assets/img/refonte-logo/logo_colissimo.png"  class="h-10"
          *ngIf="stringContain(shippingMode.name, 'colissi')">

        <div fxLayout="column" fxFlex>

          <!-- Infos (Name, prix...) -->
          <div fxLayoutAlign="space-between center">
            <span class="mat-caption boldest">{{shippingMode.name}}</span>
            <span class="mat-caption" *ngIf="shippingMode.price > 0">&nbsp;&nbsp;{{shippingMode.price |
              priceFilter}}</span>
            <span class="mat-caption great-ico"
              *ngIf="shippingMode.price === 0">&nbsp;&nbsp;{{"basket.offer"|translate}}</span>
          </div>

          <!-- Delais -->
          <div>
            <span class="mat-caption" style="color:gray">{{'AddressEnorderComponent.deliverydelay'|translate}} {{shippingMode.delay_days}}
              {{'AddressEnorderComponent.day'|translate}}{{shippingMode.delay_days > 1 ? 's' : ''}} {{'AddressEnorderComponent.opened'|translate}}{{shippingMode.delay_days > 1 ? 's' : ''}}</span>
          </div>

          <!-- Offert -->
          <div *ngIf="shippingMode.price > 0 && shippingMode.offered_from">
            <span class="mat-caption" style="font-size: 10px;">{{"basket.shipping-cost-offer"| translate}}
              {{shippingMode.offered_from | priceFilter}}</span>
          </div>

          <!-- Panier trop lourd -->
          <div *ngIf="shippingMode.to_much_weight" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <div>
              <span class="mat-caption warn-ico">{{'AddressEnorderComponent.maxweight'|translate}} {{shippingMode.to_much_weight}}kg)</span>
            </div>
            <div fxLayoutAlign="center center">
              <i class="material-icons clicked icon-info warn-ico" angulartics2On="click"
                angularticsAction="openWeightTableDial" angularticsCategory="order"
                matTooltip="{{'basket.rate-weight-prices'|translate}}"
                (click)="myDials.openWeightTableDial(currAddress$); $event.stopPropagation()">info</i>
            </div>
          </div>
        </div>

        <!-- Radio button -->
        <!-- <div fxLayout="column" fxLayoutAlign="center center" fxFlex="10">

          <div class="fake-radio" [class.great]="shippingMode.id === currAddress$.shipping_mode.id"></div>

          <app-fake-radio-button [checked]="shippingMode.id === currAddress$.shipping_mode.id ? true : false">
          </app-fake-radio-button>

        </div> -->


      </div>
      </div>

    </div>

  </div>

  <!-- Relay card-->
  <div fxLayout="column" fxLayoutGap="10px" (click)="openMondialRelayDial();"
    *ngIf="selectedShippingMode && selectedShippingMode.is_relay>0">

    <!-- Address title-->
    <div fxLayout=" row" fxLayoutAlign="space-between center">

      <span class="title-endorder-card boldest" *ngIf="currSM.enable_shipping_cost> 0">{{"endorder.expedition-address"
        | translate| capitalize}}</span>
      <span class="title-endorder-card" *ngIf="currSM.enable_delivery>
        0">{{"endorder.delivry-address" | translate | uppercase}}</span>

      <span class="mat-subheading-1 boldest primary-ico clicked" (click)="openMondialRelayDial();"
        [class.isDisabled]="loader">{{"button.modify"|translate}}</span>

    </div>

    <!-- Address title-->
    <div class="fake-form-field-endorder" *ngIf="selectedRelay">

      <div fxLayout="column" fxLayoutAlign="center start" fxFlex>

        <div fxLayout="row" fxLayoutAlign="start center">
          <span class="mat-caption boldest" style="color:grey;">{{selectedRelay.Nom}}</span>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center">
          <span class="mat-subheading-1">{{selectedRelay.Adresse1
            | descFilter: 60 | capitalize}}, {{selectedRelay.CP}},
            {{selectedRelay.Ville
            | uppercase}}</span>
        </div>

      </div>

    </div>

    <!-- Select address-->
    <div fxLayout="column" fxLayoutAlign="center start" class="fake-form-field-endorder" *ngIf="!selectedRelay"
      id="delivryaddress" [ngClass]="{
      'animErr warn': error === 'relayneeded' && !selectedRelay
      }">

      <div fxLayout="row" fxLayoutAlign="start center">
        <span class="mat-subheading-1">{{"endorder.select-address" | translate | capitalize}}</span>
      </div>

    </div>

  </div>


  <!-- Address card -->
  <div fxLayout="column" fxLayoutGap="10px" (click)="openDialAddress();"
    *ngIf="selectedShippingMode && selectedShippingMode.is_relay < 1 || !selectedShippingMode">

    <!-- Address title-->
    <div fxLayout=" row" fxLayoutAlign="space-between center">

      <span class="title-endorder-card boldest" *ngIf="type === 'billing'">{{
        "endorder.billing-address" | translate | capitalize
        }}</span>
      <span class="title-endorder-card boldest"
        *ngIf="currSM.enable_shipping_cost> 0 && type === 'delivry'">{{"endorder.expedition-address"
        | translate| capitalize}}</span>
      <span class="title-endorder-card boldest" *ngIf="currSM.enable_delivery>
    0 && type === 'delivry'">{{"endorder.delivry-address" | translate | capitalize}}</span>

      <span class="mat-subheading-1 boldest primary-ico clicked" (click)="openDialAddress(); $event.stopPropagation();"
        [class.isDisabled]="loader">{{"button.modify"|translate}}</span>

    </div>

    <!-- Address title-->
    <div class="fake-form-field-endorder" *ngIf="currAddress$">

      <div fxLayout="column" fxLayoutAlign="center start" fxFlex>

        <div fxLayout="row" fxLayoutAlign="start center">
          <span class="mat-caption boldest" style="color:grey;">{{currAddress$.name |capitalize}}</span>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center">
          <span class="mat-subheading-1">{{currAddress$.address | capitalize}}, {{currAddress$.postal}},
            {{currAddress$.city_name | uppercase}}</span>
        </div>

      </div>

    </div>

    <!-- Select address-->
    <div fxLayout="column" fxLayoutAlign="center start" class="fake-form-field-endorder" *ngIf="!currAddress$"
      id="delivryaddress" [ngClass]="{
      'animErr warn': error === 'billingaddress' && !currAddress$ ||  error === 'delivryaddress' && !currAddress$
      }">

      <div fxLayout=" row" fxLayoutAlign="start center">
        <span class="mat-subheading-1">{{"endorder.select-address" | translate | capitalize}}</span>
      </div>

    </div>

  </div>

</div>
